import { restApi } from "@/lib/rest-api-client";
import axios from "axios";

export function getErrorMsg(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message ?? error.message;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong!!!";
}

export const GET_OTP_CONTACT = (hmoId: string, providerId: string) => {
  return restApi.post(`consultations/otp/contact`, {
    hmoId,
    providerId,
  });
};

export const SEND_EMAIL_OTP = (
  hmoId: string,
  providerId: string,
  channel: string,
  email: string,
) => {
  return restApi.post(`consultations/otp/initiate`, {
    hmoId,
    providerId,
    channel,
    email,
  });
};

export const SEND_PHONE_OTP = (
  hmoId: string,
  providerId: string,
  channel: string,
  phoneNumber: string,
) => {
  return restApi.post(`consultations/otp/initiate`, {
    hmoId,
    providerId,
    channel,
    phoneNumber,
  });
};

export const RESEND_OTP = (hmoId: string, providerId: string) => {
  return restApi.post(`consultations/otp/resend`, {
    hmoId,
    providerId,
  });
};

export const VERIFY_OTP = (hmoId: string, providerId: string, otp: string) => {
  return restApi.post(`consultations/otp/verify`, {
    hmoId,
    providerId,
    otp,
  });
};
